module.exports = { "default": require("core-js/library/fn/array/map"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/map.js
// module id = 817
// module chunks = 0